import { Grid, useMediaQuery } from "@mui/material";
import { DateField, Labeled, ReferenceField, SelectField, TextField } from "react-admin";

import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";
import { IncomingStudentGenderOptions } from "utils/choices";

const PersonalDataSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Лични данни"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={6}
          xl={3}
        >
          <Labeled label="Име">
            <TextField
              source="userInfo.firstName"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          xl={3}
        >
          <Labeled label="Фамилия">
            <TextField
              source="userInfo.lastName"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          xl={3}
        >
          <Labeled label="Име (латиница)">
            <TextField
              source="userInfo.firstNameLatin"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          xl={3}
        >
          <Labeled label="Фамилия (латиница)">
            <TextField
              source="userInfo.lastNameLatin"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          xl={3}
        >
          <Labeled label="Пол">
            <SelectField
              source="userInfo.gender"
              choices={IncomingStudentGenderOptions}
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          xl={3}
        >
          <Labeled label="Националност">
            <ReferenceField
              source="userInfo.countryId"
              reference={administrationRequests.getCountriesSelect()}
              emptyText="-"
              link={false}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          xl={3}
        >
          <Labeled label="Имейл">
            <TextField
              source="userInfo.email"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          xl={3}
        >
          <Labeled label="Дата на раждане">
            <DateField
              locales="bg-BG"
              source="userInfo.birthDate"
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default PersonalDataSection;
